import React, {Component} from "react";
import "./PageSection.css";

import {joinClasses} from "utils";

export default class PageSection extends Component
{
	render()
	{
		const classes = joinClasses(
		[
			"page-section",
			this.props.className
		]);

		return (
			<div ref={this.props.handleRef} className={classes} style={this.props.style}>
				<div className="inner">
					{this.props.children}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/PageSection/PageSection.js